import _extends from "@babel/runtime/helpers/extends";
var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/Header/DesktopHeader.js",
  _this = this;
import React from 'react';
import Grid from '../Grid';
import Row from '../Row';
import Column from '../Column';
import Text from '../Text';
import DesktopMenu from './DesktopMenu';
import Logo from './Logo';
import IconMenu from './IconMenu';
import styled, { css } from 'styled-components';
import { withTheme } from '../../core/ThemeProvider';
import Search from './Search';
var StyledDesktopHeader = withTheme(styled.div.withConfig({
  displayName: "DesktopHeader__StyledDesktopHeader",
  componentId: "sc-1ik09fh-0"
})(function (props) {
  return css(["display:none;width:100%;z-index:99;@media (min-width:", "){display:block;}"], props.coreTheme.brk_md);
}));
var StyledDesktopHeaderGrid = styled(Grid).withConfig({
  displayName: "DesktopHeader__StyledDesktopHeaderGrid",
  componentId: "sc-1ik09fh-1"
})(["padding-top:0;padding-bottom:0;"]);
var StyledDesktopHeaderColumn = styled(Column).withConfig({
  displayName: "DesktopHeader__StyledDesktopHeaderColumn",
  componentId: "sc-1ik09fh-2"
})(["padding-top:0;padding-bottom:0;"]);
var StyledMenuItemList = styled.ul.withConfig({
  displayName: "DesktopHeader__StyledMenuItemList",
  componentId: "sc-1ik09fh-3"
})(["display:flex;align-items:center;flex-wrap:wrap;list-style-type:none;margin:0;padding:0;height:100%;float:right;> li{margin-left:22px;}"]);
var StyledListItem = styled.li.withConfig({
  displayName: "DesktopHeader__StyledListItem",
  componentId: "sc-1ik09fh-4"
})(["display:flex;margin:0;padding:0;"]);
var StyledListItemText = withTheme(styled(Text).withConfig({
  displayName: "DesktopHeader__StyledListItemText",
  componentId: "sc-1ik09fh-5"
})(function (props) {
  return css(["color:", ";font-size:", ";font-family:", ";"], props.coreTheme.header.deskTopRHSMenuFontColor, props.coreTheme.fs_sm, props.secondary ? props.coreTheme.header.deskTopRHSMenuInactiveFont : props.coreTheme.header.deskTopRHSMenuActiveFont);
}));
var StyledMenuItemListPrimary = styled.ul.withConfig({
  displayName: "DesktopHeader__StyledMenuItemListPrimary",
  componentId: "sc-1ik09fh-6"
})(["display:flex;flex-wrap:wrap;list-style-type:none;margin:0;padding:0;height:100%;"]);
var RHSControlListItem = styled.li.withConfig({
  displayName: "DesktopHeader__RHSControlListItem",
  componentId: "sc-1ik09fh-7"
})(["display:flex;align-items:center;&:first-child{margin:0;}"]);
var DesktopTopRHSMenuItems = function DesktopTopRHSMenuItems(_ref) {
  var baseUrl = _ref.baseUrl,
    items = _ref.items;
  return items.map(function (item, key) {
    return /*#__PURE__*/React.createElement(StyledListItem, {
      key: key,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 91,
        columnNumber: 7
      }
    }, item.active ? /*#__PURE__*/React.createElement(StyledListItemText, {
      lineHeight: "medium",
      type: "link",
      href: "".concat(baseUrl).concat(item.href),
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 93,
        columnNumber: 11
      }
    }, item.title) : /*#__PURE__*/React.createElement(StyledListItemText, {
      type: "link",
      lineHeight: "medium",
      href: "".concat(baseUrl).concat(item.href),
      secondary: true,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 101,
        columnNumber: 11
      }
    }, item.title));
  });
};
var DesktopRHSControls = function DesktopRHSControls(_ref2) {
  var baseUrl = _ref2.baseUrl,
    menuIcons = _ref2.menuIcons,
    searchConfigOptions = _ref2.searchConfigOptions;
  return /*#__PURE__*/React.createElement(StyledMenuItemList, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 116,
      columnNumber: 3
    }
  }, searchConfigOptions.showSearch && /*#__PURE__*/React.createElement(RHSControlListItem, {
    "data-testid": "desktop-search-menu-list-item",
    key: 'icon-menu-search',
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 118,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Search, _extends({}, searchConfigOptions, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 122,
      columnNumber: 9
    }
  }))), menuIcons.map(function (menuIcon, key) {
    return /*#__PURE__*/React.createElement(RHSControlListItem, {
      key: key,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 127,
        columnNumber: 9
      }
    }, /*#__PURE__*/React.createElement(IconMenu, {
      baseUrl: baseUrl,
      icon: menuIcon.icon,
      subMenu: menuIcon.subMenu,
      "data-testid": "icon-menu-".concat(key + 1),
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 128,
        columnNumber: 11
      }
    }));
  }));
};
var DesktopHeader = function DesktopHeader(_ref3) {
  var baseUrl = _ref3.baseUrl,
    logo = _ref3.logo,
    firstLevelLinks = _ref3.firstLevelLinks,
    menuItems = _ref3.menuItems,
    menuIcons = _ref3.menuIcons,
    menuHoverKey = _ref3.menuHoverKey,
    onMenuMouseEnter = _ref3.onMenuMouseEnter,
    onMenuMouseLeave = _ref3.onMenuMouseLeave,
    onMenuItemClick = _ref3.onMenuItemClick,
    searchConfigOptions = _ref3.searchConfigOptions;
  return /*#__PURE__*/React.createElement(StyledDesktopHeader, {
    "data-testid": "desktop-header",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 152,
      columnNumber: 3
    }
  }, /*#__PURE__*/React.createElement(StyledDesktopHeaderGrid, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 153,
      columnNumber: 5
    }
  }, firstLevelLinks && /*#__PURE__*/React.createElement(Row, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 155,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(StyledDesktopHeaderColumn, {
    xs: 9,
    lg: 8,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 156,
      columnNumber: 11
    }
  }), /*#__PURE__*/React.createElement(StyledDesktopHeaderColumn, {
    xs: 3,
    lg: 4,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 157,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(StyledMenuItemList, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 158,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(DesktopTopRHSMenuItems, {
    baseUrl: baseUrl,
    items: firstLevelLinks,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 160,
      columnNumber: 15
    }
  })))), /*#__PURE__*/React.createElement(Row, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 168,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Column, {
    xs: 8,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 169,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(StyledMenuItemListPrimary, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 170,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(StyledListItem, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 171,
      columnNumber: 13
    }
  }, logo && /*#__PURE__*/React.createElement(Logo, {
    baseUrl: baseUrl,
    href: logo.href,
    alt: logo.alt,
    src: logo.src,
    mode: "deskTop",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 174,
      columnNumber: 17
    }
  })), menuIcons && /*#__PURE__*/React.createElement(DesktopMenu, {
    baseUrl: baseUrl,
    menuItems: menuItems,
    hasMenuIcons: menuIcons,
    menuHoverKey: menuHoverKey,
    onMenuMouseEnter: onMenuMouseEnter,
    onMenuMouseLeave: onMenuMouseLeave,
    onMenuItemClick: onMenuItemClick,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 185,
      columnNumber: 15
    }
  }))), /*#__PURE__*/React.createElement(Column, {
    xs: 4,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 197,
      columnNumber: 9
    }
  }, menuIcons && /*#__PURE__*/React.createElement(DesktopRHSControls, {
    baseUrl: baseUrl,
    menuIcons: menuIcons,
    searchConfigOptions: searchConfigOptions,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 200,
      columnNumber: 13
    }
  }), !menuIcons && /*#__PURE__*/React.createElement(StyledMenuItemList, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 207,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(DesktopMenu, {
    baseUrl: baseUrl,
    menuItems: menuItems,
    hasMenuIcons: menuIcons,
    menuHoverKey: menuHoverKey,
    onMenuMouseEnter: onMenuMouseEnter,
    onMenuMouseLeave: onMenuMouseLeave,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 208,
      columnNumber: 15
    }
  }))))));
};
export default DesktopHeader;